import { TweenLite, Power2 } from 'gsap'

import TimeMixin from '@/mixins/Time.js'
import MouseMixin from '@/mixins/Mouse.js'
import EventHubMixin from '@/mixins/EventHub.js'
import APIMixin from '@/mixins/API.js'
import SizesMixin from '@/mixins/Sizes.js'
import AppIconPlay from '@/components/app-icon-play'

export default
{
    name: 'app-page-stories',

    components:
    {
        AppIconPlay
    },

    mixins:
    [
        TimeMixin,
        MouseMixin,
        EventHubMixin,
        APIMixin,
        SizesMixin
    ],

    data()
    {
        return {
            title: '',
            subTitle: '',
            description: '',
            type: '',
            cta: '',
            slug: 'dummy',
            content: null,
            active: false
        }
    },

    created()
    {
        this.focused = false
        this.stories = []

        window.setTimeout(() =>
        {
            this.fetch('stories', { per_page: 1000 }, (data, error) =>
            {
                // Error
                if(error === true || !(data instanceof Array))
                {
                    this.$router.push({ name: '404' })
                    return
                }

                this.stories = data

                if(this.pendingItem)
                {
                    this.gridFocusItem(this.pendingItem)
                }
            })
        }, 2000)

        this.fetch('pages', { slug: 'stories', per_page: 1000 }, (data, error) =>
        {
            // Error
            if(error === true || data.length < 1)
            {
                this.$router.push({ name: '404' })
                return
            }

            this.content = data[0]

            // SEO
            document.title = this.content.acf.seo_title ? this.content.acf.seo_title : ''
            if(this.content.acf.seo_description)
            {
                document.querySelector('meta[name=description]').content = this.content.acf.seo_description
            }

            // Papillon
            this.$nextTick(() =>
            {
                window.dispatchEvent(new Event('papillon'))
            })

            // Next tick
            this.$nextTick(() =>
            {
                // Back
                this.$eventHub.$emit('headerLogo.setState', { state: 'back', backDefaultMode: 'white', backText: this.content.acf.label_back_to_chapters, backTo: { name: `${this.$route.meta.lang}_chapters` } })

                this.stroke.$dragCta = this.$refs.dragCta
                this.stroke.$discoverCta = this.$refs.discoverCta

                if(!this.$root.config.platform.touch)
                {
                    this.stroke.$discoverCta.addEventListener('mouseenter', this.stroke.mouseenter)
                    this.stroke.$discoverCta.addEventListener('mouseleave', this.stroke.mouseleave)
                }

                this.stroke.dragCtaBounding = this.stroke.$dragCta.getBoundingClientRect()
                TweenLite.to(this.stroke, 1, { x: this.stroke.dragCtaBounding.left, length: this.stroke.dragCtaBounding.width, ease: Power2.easeOut })
            })
        }, this.$root.isFirstPage())
    },

    mounted()
    {
        // Stroke
        this.stroke = {}
        this.stroke.$dragCta = null
        this.stroke.$discoverCta = null
        this.stroke.x = 0
        this.stroke.length = 100
        this.stroke.lineWidth = 1
        this.stroke.strokeStyle = '#ffffff'
        this.stroke.dragCtaBounding = null
        this.stroke.discoverCtaBounding = null

        this.stroke.mouseenter = () =>
        {
            TweenLite.to(this.stroke, 0.5, { length: this.stroke.discoverCtaBounding.width, ease: Power2.easeOut })
        }

        this.stroke.mouseleave = () =>
        {
            TweenLite.to(this.stroke, 0.5, { length: 20, ease: Power2.easeOut })
        }

        this.$eventHub.$emit('line.createStroke', this.stroke)

        // Grid
        this.$eventHub.$on('grid.focusItem', this.gridFocusItem)
        this.$eventHub.$on('grid.unFocus', this.gridUnFocus)
        this.$eventHub.$on('grid.chooseItem', this.gridChooseItem)

        if(!this.content)
        {
            this.$eventHub.$emit('headerLogo.setState', { state: 'logo' })
        }

        this.$eventHub.$emit('line.setElement', this.$refs.lineMark)
        this.$eventHub.$emit('line.moveToElement')
    },

    destroyed()
    {
        this.destroyed = true

        if(!this.$root.config.platform.touch)
        {
            this.stroke.$discoverCta.removeEventListener('mouseenter', this.stroke.mouseenter)
            this.stroke.$discoverCta.removeEventListener('mouseleave', this.stroke.mouseleave)
        }

        let $eventHub = this.$eventHub
        let stroke = this.stroke

        TweenLite.to(this.stroke, 1, { x: this.sizes.width, length: 30, ease: Power2.easeInOut, onComplete()
        {
            $eventHub.$emit('line.deleteStroke', stroke)
            $eventHub = null
            stroke = null
        } })

        this.$eventHub.$off('grid.focusItem', this.gridFocusItem)
        this.$eventHub.$off('grid.unFocus', this.gridUnFocus)
        this.$eventHub.$off('grid.chooseItem', this.gridChooseItem)
    },

    methods:
    {
        onResize()
        {
            if(this.stroke.$dragCta)
            {
                this.stroke.dragCtaBounding = this.stroke.$dragCta.getBoundingClientRect()
            }

            if(this.stroke.$discoverCta)
            {
                this.stroke.discoverCtaBounding = this.stroke.$discoverCta.getBoundingClientRect()
            }


            if(!this.focused)
            {
                this.stroke.x = this.stroke.dragCtaBounding.left
                this.stroke.length = this.stroke.dragCtaBounding.width
            }

        },

        onCloseClick()
        {
            this.$eventHub.$emit('grid.setUnfocus')
        },

        gridFocusItem(item)
        {
            this.focused = true

            // Stories aren't loaded yet
            if(this.stories.length === 0)
            {
                this.pendingItem = item
                return
            }

            // Find stories and change contents
            const story = this.stories.find((_story) => _story.id === item.id)

            this.story = story
            this.type = story.acf.type.value
            this.title = story.acf.title
            this.description = story.acf.description
            this.cta = story.acf.cta

            switch(story.acf.type.value)
            {
                case 'story':
                    this.subTitle = this.content.acf.label_gallery
                    break

                case 'gallery':
                    this.subTitle = this.content.acf.label_story_of.replace('[NAME]', story.acf.person_name)
                    break

                case 'video':
                    this.subTitle = story.acf.sub_title
                    break
            }


            this.$eventHub.$emit('headerLogo.setState', { state: 'hidden' })

            window.setTimeout(() =>
            {
                // Test if still focused
                if(this.focused)
                {
                    this.$eventHub.$emit('line.setElement', this.$refs.lineMarkFocus, true)

                    this.stroke.discoverCtaBounding = this.stroke.$discoverCta.getBoundingClientRect()
                    TweenLite.to(this.stroke, 1, { x: this.stroke.discoverCtaBounding.left, length: 20, ease: Power2.easeOut })
                }
            }, 650)

            this.active = true
        },

        gridUnFocus()
        {
            this.focused = false

            window.setTimeout(() =>
            {
                if(!this.destroyed)
                {
                    TweenLite.to(this.stroke, 1, { x: this.stroke.dragCtaBounding.left, length: this.stroke.dragCtaBounding.width, ease: Power2.easeOut })
                }
            }, 650)

            if(this.content)
            {
                this.$eventHub.$emit('headerLogo.setState', { state: 'back', backDefaultMode: 'white', backText: this.content.acf.label_back_to_chapters, backTo: { name: `${this.$route.meta.lang}_chapters` } })
            }
            else
            {
                this.$eventHub.$emit('headerLogo.setState', { state: 'logo' })
            }

            this.$eventHub.$emit('line.setElement', this.$refs.lineMark, true)

            this.active = false
        },

        gridChooseItem()
        {
            if(this.story.acf.type.value === 'video')
            {
                // Open URL
                if(this.story.acf.video.url)
                {
                    window.open(this.story.acf.video.url, '_blank')
                }

                // Open player
                else
                {
                    console.log(this.story.acf.video.ID)
                    // this.$eventHub.$on('player.activate', this.story.id)
                    this.$eventHub.$emit('player.activate', this.story.acf.video.ID)
                }
            }
            else
            {
                this.$router.push({ name: `${this.$route.meta.lang}_story`, params: { storySlug: this.story.acf.slug } })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-stories/script.js